// extracted by mini-css-extract-plugin
export default {"drawer":"Drawer_drawer__clbtr","logo":"Drawer_logo__E2lqJ","resume":"Drawer_resume__ErCJ2","closed":"Drawer_closed__ds1pi","open":"Drawer_open__GPKnn"};